import type { Asset } from '../../../types/asset.types';

// Treat null-typed assets as photos: legacy-migrated assets predate the
// type column and arrive as `null`; current assets surface as 'photo'.
export const isPhotoAsset = (asset: Pick<Asset, 'type'>) =>
  asset.type === 'photo' || asset.type === null;
